import { IMutableWidgetsMap, TCommonData, TMutableWidgetsData, TMutableWidgetsOption, TWidget } from '@libs/types';

export const removeWidget = (
    mutableWidgets: IMutableWidgetsMap<TMutableWidgetsData, TMutableWidgetsOption>,
    widgetUid: TWidget<TCommonData>['uid'],
): IMutableWidgetsMap<TMutableWidgetsData, TMutableWidgetsOption> => {
    const widgetForRemove = { ...mutableWidgets[widgetUid] };
    if (widgetForRemove) {
        delete mutableWidgets[widgetUid];
        if (widgetForRemove.widgets?.length > 0) {
            widgetForRemove.widgets.forEach((uid) => removeWidget(mutableWidgets, uid));
        }
    }
    return mutableWidgets;
};
